export function firstDefined(obj, keys) {
  for (const k of keys) {
    const v = obj?.[k];
    if (v != null && v !== "") return v;
  }
  return "";
}

export function isPlainObject(v) {
  return v != null && typeof v === "object" && !Array.isArray(v);
}
